// extracted by mini-css-extract-plugin
export var scrollArea = "_ok-0";